module.exports = __webpack_public_path__ + "img/homeIc4.327f1aa2.png";